import { useEffect, useState } from "react";
import { SaveTypeCatalog } from "./TypeCatalogService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIndexLogic } from "./index-logic";
import { useInventoryPermission } from "../permissions/InventoryPermissions";

export const useAddMaterialTypeLogic = ({ handleClose, setLoading, open, selectedMaterialType }) => {
  //#region Permissions
  const { InventoryPermissionProps } = useInventoryPermission();
  const {
    hasTypeCatalogSavePermission,
  } = InventoryPermissionProps;
  //#endregion Permissions

  const { IndexProps } = useIndexLogic();
  const { loadData } = IndexProps;
  
  // Form state
  const [materialTypeForm, setMaterialTypeForm] = useState({
    typeCatalogID: 0,
    entityType: "Material",
    typeName: "",
    description: "",
    name: "", // The API schema includes this but it might be redundant with typeName
    isActive: true
  });

  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    if (open) {
      if (selectedMaterialType) {
        setMaterialTypeForm({
          ...selectedMaterialType
        });
      } else {
        // Reset for a new material type
        resetForm();
      }
    }
  }, [open, selectedMaterialType]);

  // Form change handlers
  const handleInputChange = (e) => {
    if(!hasTypeCatalogSavePermission) return;

    const { name, value } = e.target;
    setMaterialTypeForm({
      ...materialTypeForm,
      [name]: value
    });
    
    // Clear error for this field if any
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    
    if (!materialTypeForm.typeName.trim()) {
      newErrors.typeName = "Material Type name is required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Save material type
  const handleSaveMaterialType = async () => {
    if(!hasTypeCatalogSavePermission) return;

    try {
      if (!validateForm()) {
        return false;
      }
      
      // setLoading(true);
      
      // Set name to typeName if empty (seems redundant in schema but ensuring all required fields are present)
      const formData = {
        ...materialTypeForm,
        name: materialTypeForm.name || materialTypeForm.typeName
      };
      
      const response = await SaveTypeCatalog(formData);
      
      if (!response.isError) {
        // First close the dialog
        handleClose();
        
        // Then refresh data and show success message
        loadData(); // Refresh all data
        toast.success(materialTypeForm.typeCatalogID ? "Material type updated successfully" : "Material type created successfully", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
        
        return true;
      } else {
        toast.error(response.message || "Failed to save material type", {
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
        console.error("Error saving material type:", response.message);
        return false;
      }
    } catch (error) {
      toast.error("An error occurred while saving the material type", {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      console.error("Error saving material type:", error);
      return false;
    } finally {
      // setLoading(false);
    }
  };

  const resetForm = () => {
    setMaterialTypeForm({
      typeCatalogID: 0,
      entityType: "Material",
      typeName: "",
      description: "",
      name: "",
      isActive: true
    });
    setErrors({});
  };

  return {
    materialTypeForm,
    errors,
    handleInputChange,
    handleSaveMaterialType,
    resetForm
  };
}; 